import { render } from "./EditInvoiceView.vue?vue&type=template&id=312fbdf5"
import script from "./EditInvoiceView.vue?vue&type=script&lang=js"
export * from "./EditInvoiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__